import React from 'react';
import PropTypes from 'prop-types';
import { Flex } from 'antd';
import { StarFilled, ExportOutlined } from '@ant-design/icons';
import styles from './school-name.module.scss';

/**
 * SchoolName
 *
 * A component to display school names with different styling based on match level.
 * - High match (green): Includes a yellow star icon
 * - Medium match (blue): No star icon
 * - Low match (purple): No star icon
 *
 * @param {Object} props - Component properties
 * @param {string} props.name - The name of the school to display
 * @param {string} props.matchLevel - The match level ('high', 'medium', 'low')
 * @param {boolean} props.showExportIcon - Whether to show the export icon
 * @param {function} props.onClick - Function to execute when the component is clicked
 */
export const SchoolName = ({ name, matchLevel = 1, showExportIcon = true, onClick }) => {
  const getContainerClassName = () => {
    switch (matchLevel) {
      case 1:
        return styles.highMatch;
      case 2:
        return styles.mediumMatch;
      case 3:
        return styles.lowMatch;
      default:
        return styles.highMatch;
    }
  };

  return (
    <Flex
      align="center"
      justify="space-between"
      className={`${styles.container} ${getContainerClassName()}`}
      onClick={onClick}>
      <Flex gap="small" align="center">
        {matchLevel === 'high' && <StarFilled className={styles.star} />}
        <span className="font-600">{name}</span>
      </Flex>
      {showExportIcon && <ExportOutlined />}
    </Flex>
  );
};

SchoolName.propTypes = {
  name: PropTypes.string.isRequired,
  showExportIcon: PropTypes.bool,
  onClick: PropTypes.func,
};
